import { render, staticRenderFns } from "./ShedTransfer.vue?vue&type=template&id=0f8417f5&scoped=true&"
import script from "./ShedTransfer.vue?vue&type=script&lang=js&"
export * from "./ShedTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ShedTransfer.vue?vue&type=style&index=0&id=0f8417f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8417f5",
  null
  
)

export default component.exports